"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8439 9.9156a6.5766 6.5766 0 0 1-.3164-2.0217c0-3.6348 2.9466-6.5814 6.5814-6.5814 1.4557 0 2.8012.4727 3.891 1.2729l-3.8503 3.856 1.4155 1.4156 3.8495-3.8579c.8019 1.0906 1.2756 2.4373 1.2756 3.8948 0 3.6348-2.9465 6.5813-6.5813 6.5813a6.5769 6.5769 0 0 1-2.0227-.3166l-7.8436 7.8436L2 17.7595l7.8439-7.8438zM20.6902 7.894c0 2.5302-2.0511 4.5813-4.5813 4.5813-.904 0-1.7468-.2617-2.4567-.7136l-7.4096 7.4121-1.4142-1.4142 7.4103-7.4129a4.5595 4.5595 0 0 1-.7112-2.4527c0-2.5303 2.0511-4.5814 4.5814-4.5814.1108 0 .2206.0039.3293.0116l-1.7028 1.7031c-.7811.781-.7811 2.0474 0 2.8285l1.4155 1.4155c.7811.7811 2.0474.7811 2.8284 0l1.6998-1.6998c.0074.1065.0111.214.0111.3225z"
  })];
};

exports.default = _default;